import * as React from "react";
import Icon from "../../../../components/atoms/Icon";
import styles from "./styles.scss";

interface Props {
  operatorId: string;
  isAdmin: boolean;
  currentOperatorId: string;
  onDelete: () => void;
}

const DeleteButton: React.FC<Props> = ({
  operatorId,
  isAdmin,
  currentOperatorId,
  onDelete,
}) => {
  if (isAdmin || operatorId === currentOperatorId) {
    return null;
  }

  return (
    <button className={styles.deleteLink} onClick={onDelete}>
      <Icon name="icon-trash" className={styles.svg} />
      <p>削除</p>
    </button>
  );
};

export default DeleteButton;
